/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// @mui material components
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Authentication layout components
import { clearState } from 'redux/actions/appAction';
import PageLayout from 'examples/LayoutContainers/PageLayout';
import * as Defi from 'services/Define';
import { FetchData } from 'services/Request';

function Logout() {
  const loading = true;
  const app = useSelector((state) => state[Defi.APP_STATE]);
  const dispatch = useDispatch();

  const logout = () => {
    FetchData('POST', `/logout`, app.token, {
      lang: app.lang,
    }).then(() => {
      window.location.replace('/signin');
    });
  };

  useEffect(() => {
    dispatch(clearState(app.authen, app.device));
    logout();
  }, []);

  return (
    <PageLayout>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </PageLayout>
  );
}

export default Logout;
